/* eslint-disable @typescript-eslint/no-explicit-any */

import { Lease } from "../../models/lease.model";
import { Property } from "../../models/property.model";
import { Tenant } from "../../models/tenant.model";
import { Unit } from "../../models/unit.model";
import BASE_API from "../../shared/utility/base-api"
import { appApi } from "../../store/app.api"
type TenantIndex = Tenant[];
type LeaseIndex = Lease[];
type UnitIndex = Unit[];
type PropertyIndex = Property[];

type SearchResult = {
  tenants_index?: TenantIndex;
  leases_index?: LeaseIndex;
  units_index?: UnitIndex;
  properties_index?: PropertyIndex;
}


const layoutQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    search: builder.query<SearchResult, string>({
      query: (query: string) => ({
        url: `${BASE_API}/search/search-all?q=${query}`,
        method: "get",
      }),
    //   providesTags: ["Tenant"],
    }),

  }),
  overrideExisting: true,
})
export const {
    useLazySearchQuery

} = layoutQuery
